<template>
    <div class="content">
        <!-- <h2>原件一致章</h2> -->
        <el-form :model="form" ref="form" :rules="rules" label-width="110px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="位置:" prop="weizhi">
                        <el-select v-model="form.weizhi" placeholder="请选择" clearable size="small">
                            <el-option label="左下角" value="左下角"></el-option>
                            <el-option label="右下角" value="右下角"></el-option>
                            <el-option label="上中间" value="上中间"></el-option>
                            <el-option label="下中间" value="下中间"></el-option>
                            <el-option label="正中间" value="正中间"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="份数:" prop="fenshu">
                        <el-select v-model="form.fenshu" placeholder="请选择" clearable size="small">
                            <el-option
                                v-for="dict in fsOptions"
                                :key="dict"
                                :label="dict"
                                :value="dict"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="日期:" prop="rq">
                        <el-date-picker size="small"
                            v-model="form.rq"
                            type="date" 
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item>
                        <el-button type="primary" @click="submit('form')">确定</el-button>
                        <el-button type="warning" @click="handleBack()">取消</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div v-show="loading" class="loading">
            <i class="el-icon-loading"></i>
            <p>文书生成中...</p>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    props:['code','pcId'],
    data() {
        return {
            loading:false,
            xm:'',
            dm:'',
            cmid:'',
            shi:'',
            xianqu:'',
            gzbm:'',
            gzzw:'',
            form:{
                weizhi:'左下角',
                fenshu:1,
                rq:this.getDate(new Date(),'yyyy-MM-dd')
            },
            rules:{
                weizhi:[
                    { required: true, message: '页数不能为空', trigger: 'blur' }
                ],
                fenshu:[
                    { required: true, message: '签名方式不能为空', trigger: 'blur' }
                ],
                rq:[
                    { required: true, message: '日期不能为空', trigger:['change', 'blur'] }
                ],
            },
            fsOptions:[],
            isWs:false,
        }
    },
    components: {
    },
    computed: {
    },
    created() {
        console.log(this.code)
    },
    async mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        // this.xm = user.xm
        // this.dm = user.dm
        // this.cmid = user.c_mid
        this.shi = user.shi
        this.xianqu = user.xianqu
        // this.gzbm = user.gzbm
        // this.gzzw = user.gzzw
        for(var i=1;i<501;i++){
            this.fsOptions.push(i)
        }
        this.getList()
    },
    methods: {
        async getList(){
            this.isWs = false
        },
        submit(form){
            this.$refs[form].validate((valid) => {
                if (valid) {
                    this.loading = true
                    axios({
                        method: 'post',
                        url: `${this.Global._baseUrl2}`,
                        data: {
                            act: "setFangzhang",
                            id: `${this.pcId}`,
                            weizhi:`${escape(this.form.weizhi)}`,
                            // fenshu:`${escape(this.form.fenshu)}`,
                            riqi:`${escape(this.form.rq)}`,
                            shi:`${escape(this.shi)}`,
                            xianqu:`${escape(this.xianqu)}`,
                        },
                        transformRequest: [function (data) {
                            data = qs.stringify(data);
                            return data;
                        }],
                        headers: { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
                    }).then(res => {
                        this.loading = false
                        console.log(res)
                        if(res.data != -1){
                            this.$message({
                                message: '设置成功',
                                type: 'success'
                            });
                            this.show(res.data)
                        }else{
                            this.$message({
                                message: '操作失败',
                                type: 'error'
                            }); 
                        }
                    }).catch(res => {
                        this.loading = false
                        this.$message({
                            message: '操作失败',
                            type: 'error'
                        }); 
                    })
                }
            })
        },
        handleBack(){
            this.$emit('handleBack',false)
        },
        show(url){
            this.url = 'https://dapc1.scqwszfd.cn:8123/'+url
            window.open(this.url,'_blank')
        }
    }
}
</script>


<style scoped>
.loading{ width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); position: fixed; top:0;left: 0;text-align: center;}
.loading i{    font-size: 80px;color: #fff;opacity: 1; margin-top: 38vh;}
.loading p{   font-size: 20px; color: #fff; opacity: 1; line-height: 50px;}
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
</style>